import React from "react";
import type { RichTextWithHeadingBlock } from "@/types/product";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import shared from "../ProductDetailContent.module.css";
import styles from "./RichTextWithHeadingSection.module.css";

export const RichTextWithHeadingSection: React.FC<{
  block: RichTextWithHeadingBlock;
}> = ({ block }) => {
  const alignment = block.alignment ?? "center";
  const badge = block.badge?.trim();

  return (
    <section className={`${shared.section} ${shared.bgFull}`}>
      <div
        className={`${shared.innerNarrow} ${styles.inner} ${
          alignment === "left" ? styles.alignLeft : styles.alignCenter
        }`}
      >
        {badge && <span className={styles.badge}>{badge}</span>}
        {block.heading && <h2 className={styles.heading}>{block.heading}</h2>}
        {block.text && (
          <div
            className={styles.body}
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(block.text) }}
          />
        )}
      </div>
    </section>
  );
};

export default RichTextWithHeadingSection;
